module.exports = __webpack_public_path__ + "fonts/Manrope-400-latin6.02fde8a.woff2";